import { path } from "../../config";
import { store } from "../../redux/store";
import fetchServer from "../fetchServer";

export async function checkBookable(data) {
  var result = {return: 0,msg: 'Error',data: {}}

  let token = store.getState().user.userData.accessToken;

  let headers = {Authorization: `Bearer ${token}`};

  await fetchServer({method: "POST",url: path.api+`/airs/air-sell-from-recommendation/`,data,
    headers
  })
  .then((res) => {
    console.log(" => ",{...res})
    if(res) {
      if(res?.data?.success) {
        result = {return: 1,msg: "Successfull",data: res.data.data};
      } else if(res?.data?.error)
        result['msg'] = res?.data?.error?.message || result.msg;
    } 
  })
  .catch((err) => {
    console.log("Network Error: ",err);
  })

  return result;

}